import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { OpportunityActivityMessage } from "./OpportunityActivityMessage";
import type { ActivityMessage } from "./opportunityActivitySentences";

/**
 * A message's one-line preview under its activity line; a click opens the
 * full message.
 * @param preview - The message's text on one line
 * @param message - The full message
 */
export const OpportunityActivityMessagePopover = ({
  preview,
  message,
}: {
  preview: string;
  message: ActivityMessage;
}) => {
  const [trigger, setTrigger] = useState<HTMLButtonElement | null>(null);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          ref={setTrigger}
          type="button"
          className="line-clamp-1 w-full rounded-sm text-left text-[13px] leading-5 text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring data-[state=open]:text-foreground"
        >
          “{preview}”
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        sideOffset={4}
        // Inside the opportunity's modal sheet, a popover portaled to the body
        // loses wheel scrolling to the sheet's scroll lock.
        container={
          trigger?.closest<HTMLElement>('[role="dialog"]') ?? undefined
        }
        className="max-h-96 w-[min(28rem,calc(100vw-2rem))] overflow-y-auto overscroll-contain p-1.5"
      >
        <OpportunityActivityMessage message={message} />
      </PopoverContent>
    </Popover>
  );
};
